// 3rd Party
import 'inputmask';
import 'inputmask/dist/inputmask/bindings/inputmask.binding';
import smoothscroll from 'smoothscroll-polyfill';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';

// IE11 Polyfills
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/Node.prototype.after';
import 'core-js';

// 3rd Party Initialize
smoothscroll.polyfill();
library.add(
    faFacebook,
    faTwitter,
    faInstagram,
    faLinkedin,
    faYoutube
);
dom.watch();

// 1st Party
import './mobile';
import { quote, retrieve, loginForm } from './elements';
import { showPopoverErrorsCallback } from './validation-methods';
import { showLoading } from './loading';
import { findAddressUsingGoogle, createJWT, retrieveQuoteValues, dominoMailerCheck } from './api';
import Cookies from 'cookies-js';
import cookieOptions from './cookie-options';
import { isValidState } from './utilities';

// Retrieve animation
retrieve.link.on('click', toggleRetrieveQuote);
retrieve.exit.on('click', toggleRetrieveQuote);
function toggleRetrieveQuote(e) {
    e.preventDefault();
    retrieve.main.toggleClass('wm-retrieve-quote--open');
    if (retrieve.main.hasClass('wm-retrieve-quote--open')) {
        setRetrieveTabIndex('0');
    } else {
        setRetrieveTabIndex('-1');
    }
    retrieve.referenceNumber.focus();
}

// Login animation
loginForm.link.on('click', toggleLoginForm);
loginForm.exit.on('click', toggleLoginForm);
function toggleLoginForm(e) {
    e.preventDefault();
    loginForm.main.toggleClass('wm-login-popup--open');
    if (loginForm.main.hasClass('wm-login-popup--open')) {
        setLoginFormTabIndex('0');
    } else {
        setLoginFormTabIndex('-1');
    }
    loginForm.userName.focus();
}

// Add gaTrackingId input
if (typeof ga !== 'undefined') {
    ga(function () {
        var trackers = ga.getAll();
        var trackingId = trackers[0].get('trackingId');
        var trackingInput = `<input type="hidden" class="gaTrackingId" name="gaTrackingId" value="${trackingId}" />`;
        if (quote.form) {
            quote.form.prepend(trackingInput);
        }
        if (retrieve.form) {
            retrieve.form.prepend(trackingInput);
        }
    });
}

// Quote retrieval redirect flow
const quoteRetrievalRedirect = async function (form, e) {
    e.preventDefault();

    await showLoading();

    var referenceNumber;
    var zipCode5;

    if (retrieve.referenceNumber.val() && retrieve.zipCode5.val()) {
        referenceNumber = retrieve.referenceNumber.val();
        zipCode5 = retrieve.zipCode5.val();
    } else if (retrieve.referenceNumberMobile.val() && retrieve.zipCode5Mobile.val()) {
        referenceNumber = retrieve.referenceNumberMobile.val();
        zipCode5 = retrieve.zipCode5Mobile.val();
    } else {
        referenceNumber = retrieve.referenceNumberQR.val();
        zipCode5 = retrieve.zipCode5QR.val();
    }

    findAddressUsingGoogle(

        zipCode5

    ).then(function (result) {

        var cookie = {
            address: {
                State: 'CA'
            },
            referenceNumber: referenceNumber,
            zipCode: zipCode5,
            jwt: '',
            gaTrackingId: retrieve.gaTrackingId.val()
        };

        Cookies.set('cms', JSON.stringify(cookie), cookieOptions);

        if (result === null) {
            window.location.href = `/cannotfind?referenceNumber=${referenceNumber}&zipCode=${zipCode5}`;
            return;
        } else if (isValidState(result.state)) {
            form.submit();
        } else {
            window.location.href = '/retrievedominoredirect';
            return;
        }

    });
};

const retrieveQuoteValidatorOptions = {
    submitHandler: async (form, e) => { await quoteRetrievalRedirect(form, e); },

    rules: {
        'PolicyNumber': {
            required: true,
            noEmpty: true
        },
        'ZipCode5': {
            required: true,
            digits: true,
            minlength: 5,
            maxlength: 5,
            noEmpty: true
        }
    },

    onkeyup: function (element) {
        if ($(element).valid()) {
            $(element)
                .removeClass('is-invalid')
                .addClass('is-valid');
        }
    },

    showErrors: function (errorMap, errorList) {
        let boundShowPopoverErrorsCallback = showPopoverErrorsCallback.bind(this);
        return boundShowPopoverErrorsCallback(errorMap, errorList, 'right');
    }
};

retrieve.form.validate(retrieveQuoteValidatorOptions);
retrieve.mobileForm.validate(retrieveQuoteValidatorOptions);
retrieve.qrForm.validate(retrieveQuoteValidatorOptions);

$(document).ready(function () {
    quote.property.fullAddress.attr('autocomplete', 'new-password');
    quote.property.unitNumber.attr('autocomplete', 'new-password');
    quote.mailing.fullAddress.attr('autocomplete', 'new-password');
    quote.mailing.unitNumber.attr('autocomplete', 'new-password');
});

function setRetrieveTabIndex(value) {
    retrieve.referenceNumber.attr('tabindex', value);
    retrieve.zipCode5.attr('tabindex', value);
    retrieve.buttonSubmit.attr('tabindex', value);
    retrieve.ccpa.attr('tabindex', value);
    retrieve.exit.attr('tabindex', value);
}
function setLoginFormTabIndex(value) {
    loginForm.userName.attr('tabindex', value);
    loginForm.password.attr('tabindex', value);
    loginForm.buttonSubmit.attr('tabindex', value);
    loginForm.exit.attr('tabindex', value);
}